export default __webpack_public_path__ + "static/media/order-accepted.5cbcff83.gif";